<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    @if (step1) {
      <ion-title class="modal-title">
      {{'passwordReset.header1' | translate}}
    </ion-title>
    } @else if (step2) {
      <ion-title class="modal-title">
      {{'passwordReset.header2' | translate}}
    </ion-title>
    } @else {
      <ion-title class="modal-title">
      {{'passwordReset.header3' | translate}}
    </ion-title>
    }

    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="closeLogin()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

@if (step1) {

  <ion-content [fullscreen]="true" class="homepage-content">
  <div class="page-content">


    <div class="select-group">
      <label class="sub-title-form-control">{{'passwordReset.subTitle' | translate}}</label>
    </div>
    
      <div class="select-group">
        <label class="label-form-control">{{'login_page.email' | translate}}</label>
        <!-- <label class="sub-label-form-control">{{'login_page.email_format' | translate}}</label> -->
        <ion-input class="bordered-input" required="true" [(ngModel)] ="email">
          
        </ion-input>
        <!-- <div class="custom-error" *ngIf="form.get('email')?.invalid && (form.get('email')?.dirty || form.get('email')?.touched)">
          <span>{{'login_page.email_format_error' | translate}}</span>
        </div> -->
      </div>

      
  </div>
</ion-content>
} @else if (step2) {

  <ion-content [fullscreen]="true" class="homepage-content">
  <div class="page-content">

    <div class="select-group">
      <label class="sub-title-form-control">{{'passwordReset.subTitle' | translate}}</label>
    </div>
      <div class="select-group">
        <label class="label-form-control">{{'passwordReset.code' | translate}}</label>
        <label class="sub-label-form-control">{{'passwordReset.codeMsg' | translate}}</label>
        <ion-input class="bordered-input" required="true"
        type="text" [(ngModel)] ="verificationCode"
        [class.invalid]="form.get('email')?.invalid && (form.get('email')?.dirty || form.get('email')?.touched)">
          
        </ion-input>
        <!-- <div class="custom-error" *ngIf="form.get('email')?.invalid && (form.get('email')?.dirty || form.get('email')?.touched)">
          <span>{{'login_page.email_format_error' | translate}}</span>
        </div> -->
      </div>

      
    
    <hr>
    
  </div>
</ion-content>
} @else if (step3) {

  <ion-content [fullscreen]="true" class="homepage-content">
  <div class="page-content">
    
    <form [formGroup]="form" (submit)="checkLogin()">
      <!-- <div class="select-group">
        <label class="sub-label-form-control">{{'login_page.email_format' | translate}}</label>
      </div> -->
      <div class="select-group">
        <label class="label-form-control">{{'account_creation.password' | translate}}</label>

        <span class="password-hint">
          • It must contain at least:
          <span
            [class.valid]="password?.value && !password?.hasError('minLength')">
            8 characters,
          </span>

          <span
            [class.valid]="password?.value && !password?.hasError('lowercase')">
            a lowercase letter,
          </span>

          <span
            [class.valid]="password?.value && !password?.hasError('uppercase')">
            an uppercase letter,
          </span>

          <span
            [class.valid]="password?.value && !password?.hasError('number')">
            a number,
          </span>

          <span
            [class.valid]="password?.value && !password?.hasError('containsName')">
            no part of your name
          </span>
        </span>
        <span class="password-hints">• It cannot be any of your last 10 passwords</span>
        <span class="password-hints">• At least 1 hour must have elapsed since you last changed it</span>
 
        <ion-input
          class="bordered-input"
          formControlName="password" [type]="showPassword ? 'text' : 'password'">
          <ion-icon slot="start" name="lock-closed" aria-hidden="true" ></ion-icon>
          <ion-button fill="clear" slot="end" aria-label="Show/hide" (click)="togglePassword()"> 
            @if (showPassword) {
              <ion-icon slot="icon-only" name="eye-off" aria-hidden="true" style="color: gray"></ion-icon>
            } @else {
              <ion-icon slot="icon-only" name="eye" aria-hidden="true" style="color: gray"></ion-icon>
            }
          </ion-button>
        </ion-input>
      </div>
      <div class="select-group">
        <label class="label-form-control">{{'account_creation.confirmPassword' | translate}}</label>
        <ion-input class="bordered-input" 
          [type]="showConfirmPassword ? 'text' : 'password'"
          formControlName="confirmPassword">
          <ion-icon slot="start" name="lock-closed" aria-hidden="true" ></ion-icon>
          <ion-button fill="clear" slot="end" aria-label="Show/hide" (click)="toggleConfirmPassword()">
            @if (showConfirmPassword) {
              <ion-icon slot="icon-only" name="eye-off" aria-hidden="true" style="color: gray"></ion-icon>
            } @else {
              <ion-icon slot="icon-only" name="eye" aria-hidden="true" style="color: gray"></ion-icon>
            }
          </ion-button>
        </ion-input>
      </div>
      <div class="select-group">
        <ion-checkbox labelPlacement="end" formControlName="policy">{{'passwordReset.signoutMsg' | translate}}</ion-checkbox>
      </div>
    </form>
    <hr>
    
  </div>
</ion-content>
}

<ion-footer [translucent]="false" class="ion-no-border ">
    <!-- Button Container -->
    <div class="button-container">
      <ion-button fill="outline" class="cancel-btn" (click)="closeLogin()" expand="block">
        {{'passwordReset.back' | translate}}
      </ion-button>
      @if (step1) {
        <ion-button class="next-btn" (click)="sendEmail()" [disabled]="email == ''" expand="block">
          {{'passwordReset.sendEmail' |translate}}
        </ion-button>
      } @else if (step2) {
        <ion-button class="next-btn" (click)="verifyOtp()" [disabled]="verificationCode == ''" expand="block">
          {{'passwordReset.verify' |translate}}
        </ion-button>

      } @else if (step3) {
        <ion-button class="next-btn" (click)="resetPassword()" [disabled]="!selectedOption" expand="block">
          {{'passwordReset.reset' |translate}}
        </ion-button>
      }
      
    </div>
</ion-footer>

